<template>
    <div>
        <v-app-bar color="#005a95" dark fixed flat>
            <v-btn @click="drawer=true" class="mt-0 ml-2" fab color="#ffffff" small>
                <v-icon color="#005a95">toc</v-icon>
            </v-btn>
            <v-row>
                    <v-col cols="6" class="text-end">
                        <div class="ml-10">
                            <strong>{{ modulo }}</strong>
                        </div>
                    </v-col>
                    <v-col cols="6" class="text-end">
                        <v-icon class="mt-n1">person</v-icon>
                        <strong class="ml-2">{{ usu }}</strong>
                    </v-col>
                </v-row>
        </v-app-bar>

        <!-- <component class="mt-15" v-bind:is="componente" :usu="usu" :contrato="contrato"></component> -->
        <component class="mt-15" v-bind:is="componente"></component>

        <v-navigation-drawer v-model="drawer" absolute temporary color="#005a95" dark>
            <v-list-item>
                <v-btn class="mt-5" @click="drawer=false" fab color="#000" dark small>
                    <v-icon>arrow_back</v-icon>
                </v-btn>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
            <v-list dense>
                <v-list-item v-for="item in myMenu" :key="item.title" link @click="goMenu(item)" class="mt-n2">
                    <v-list-item-icon>
                        <v-icon class="ml-5">{{ item.icon }}</v-icon>                
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>                        
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <div class="pa-2">
                    <v-btn @click="goLogin()" block color="#000" dark>
                        Cerrar Sesion
                    </v-btn>
                </div>
            </template>
        </v-navigation-drawer>  
    </div>
</template>
<script>
import Bienvenido from "@/components/Bienvenido.vue";
import Dashboard from "@/components/Dashboard.vue";
import OrdenTrabajo from "@/components/OrdenTrabajo.vue";
import Productos from "@/components/Productos.vue";
import Devoluciones from "@/components/Devoluciones.vue";
import Inventario from "@/components/Inventario.vue";
import Ajuste from "@/components/Ajuste.vue";
import Usuarios from "@/components/Usuarios.vue";
import OrdenCompra from "@/components/OrdenCompra.vue";
import Reporte from "@/components/Reporte.vue";
import Login from "@/components/Acceso.vue";
export default {
  name: 'Acceso',
  components:{Bienvenido, Dashboard, OrdenTrabajo, Productos, Inventario, Ajuste, Usuarios, Devoluciones, OrdenCompra, Reporte, Login},
  data: () => ({
    usu:'',
    contrato:'',
    drawer:false,
    myMenu:[
        {id:1, title:'Dashboard', component: 'Dashboard', icon:'home'},
        {id:2, title:'Orden de Trabajo', component: 'OrdenTrabajo', icon:'shopping_cart'},
        {id:3, title:'Productos', component: 'Productos', icon:'art_track'},
        {id:4, title:'Devoluciones', component: 'Devoluciones', icon:'remove_shopping_cart'},
        {id:5, title:'Inventario', component: 'Inventario', icon:'iso'},
        {id:6, title:'Ajuste', component: 'Ajuste', icon:'compare'},
        {id:7, title:'Usuarios', component: 'Usuarios', icon:'account_box'},
        {id:8, title:'Orden de Compra', component: 'OrdenCompra', icon:'shopping_cart'},
        {id:10, title:'Reporte', component: 'Reporte', icon:'report'},
    ],
    content:0,
    modulo:'BIENVENIDO',
    componente:'Bienvenido',

  }),
    created() { 
    window.addEventListener("onload", e => { 
      e.preventDefault(); 
      // Oculte el evento para que pueda activarse más tarde. 
      this.deferredPrompt = null; 
    });
  }, 

  async mounted(){
    const myUser = localStorage.getItem('dops_myuser');
    const myContrato = localStorage.getItem('dops_mycontrato');
    if(myUser!=null && myContrato!=null){
        this.usu = myUser;
        this.contrato = myContrato;
    }
  },
  methods:{
    goMenu(menu){
        this.modulo=menu.title.toUpperCase();
        this.componente=menu.component;
        this.drawer=false;    
    },
    goLogin(){
        localStorage.removeItem('dops_apikey');
        localStorage.removeItem('dops_myuser');
        localStorage.removeItem('dops_mycontrato');
        localStorage.removeItem('dops_timeuser');
        this.$router.push({name:'Login'})
        //window.location.href = '/';
    }
  }
}
</script>
